import { TPayDirectFormKeys } from '../../interfaces/payDetails'
import { Labels, Required } from '../global'

const metadata: TPayDirectFormKeys = {
  office: {
    label: Labels.SEARCH_FOR_OFFICE,
    id: 'office',
    type: 'text',
    required: Required.OFFICE,
  },
  itemType: {
    label: Labels.ITEM_TYPE,
    id: 'itemType',
    type: 'text',
    required: Required.ITEM_TYPE,
  },
  amount: {
    label: Labels.AMOUNT,
    id: 'amount',
    type: 'text',
    required: Required.AMOUNT,
  },
  desc: {
    id: 'desc',
    label: Labels.DESC,
    type: 'text',
    required: Required.GENERAL,
    max: 'Must be below 90 characters',
  },
  itemList: {
    id: 'itemList',
    label: Labels.DESC,
    type: 'text',
    required: Required.GENERAL,
    max: 'Must be below 90 characters',
  },
  id: {
    id: 'id',
    label: Labels.DESC,
    type: 'text',
    required: Required.GENERAL,
    max: 'Must be below 90 characters',
  },
  list: {
    id: 'list',
    label: Labels.DESC,
    type: 'text',
    required: Required.GENERAL,
    max: 'Must be below 90 characters',
  },
}

export default metadata
